import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0fa76ef0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "p-mx-2" }
const _hoisted_3 = { class: "p-mx-2" }
const _hoisted_4 = { class: "p-mt-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-text-center p-p-3" }, "No records found", -1))
const _hoisted_6 = { class: "p-dialog-titlebar p-dialog-titlebar-icon" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "warning-content p-mb-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-triangle" }),
  /*#__PURE__*/_createTextVNode(" WARNING: By Changing any numeric value listed in this screen will cause serious effects on accounting records of inventory. ")
], -1))
const _hoisted_8 = { class: "p-grid" }
const _hoisted_9 = { class: "p-col" }
const _hoisted_10 = { class: "p-field" }
const _hoisted_11 = {
  key: 0,
  class: "p-error"
}
const _hoisted_12 = { class: "p-field" }
const _hoisted_13 = {
  key: 0,
  class: "p-error"
}
const _hoisted_14 = { class: "p-field" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "barcode" }, "Barcode", -1))
const _hoisted_16 = { class: "p-field" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "productType" }, "Product Type", -1))
const _hoisted_18 = {
  key: 0,
  class: "p-error"
}
const _hoisted_19 = { class: "p-field" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "Description" }, "Description", -1))
const _hoisted_21 = { class: "p-field" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "brand" }, "Brand", -1))
const _hoisted_23 = {
  key: 0,
  class: "p-error"
}
const _hoisted_24 = { class: "p-col" }
const _hoisted_25 = { class: "p-field" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "brandSector" }, "Brand Sector", -1))
const _hoisted_27 = {
  key: 0,
  class: "p-error"
}
const _hoisted_28 = { class: "p-field" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "category" }, "Category", -1))
const _hoisted_30 = {
  key: 0,
  class: "p-error"
}
const _hoisted_31 = { class: "p-field" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "sideEffects" }, "Side Effects", -1))
const _hoisted_33 = { class: "p-field" }
const _hoisted_34 = {
  key: 0,
  class: "p-error"
}
const _hoisted_35 = { class: "p-field" }
const _hoisted_36 = {
  key: 0,
  class: "p-error"
}
const _hoisted_37 = { class: "p-field" }
const _hoisted_38 = {
  key: 0,
  class: "p-error"
}
const _hoisted_39 = { class: "p-col" }
const _hoisted_40 = { class: "p-field" }
const _hoisted_41 = {
  key: 0,
  class: "p-error"
}
const _hoisted_42 = { class: "p-field" }
const _hoisted_43 = {
  key: 0,
  class: "p-error"
}
const _hoisted_44 = { class: "p-field" }
const _hoisted_45 = {
  key: 0,
  class: "p-error"
}
const _hoisted_46 = { class: "p-field" }
const _hoisted_47 = {
  key: 0,
  class: "p-error"
}
const _hoisted_48 = { class: "p-field" }
const _hoisted_49 = {
  key: 0,
  class: "p-error"
}
const _hoisted_50 = { class: "p-field" }
const _hoisted_51 = {
  key: 0,
  class: "p-error"
}
const _hoisted_52 = { class: "p-col" }
const _hoisted_53 = { class: "p-field" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "packSalePrice" }, "Pack Sale Price", -1))
const _hoisted_55 = { class: "p-field" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "stripSalePrice" }, "Strip Sale Price", -1))
const _hoisted_57 = { class: "p-field" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unitSalePrice" }, "Unit Sale Price", -1))
const _hoisted_59 = { class: "p-field" }
const _hoisted_60 = {
  key: 0,
  class: "p-error"
}
const _hoisted_61 = {
  key: 0,
  class: "p-field"
}
const _hoisted_62 = { for: "tax_1" }
const _hoisted_63 = {
  key: 1,
  class: "p-field"
}
const _hoisted_64 = { for: "tax_2" }
const _hoisted_65 = {
  key: 2,
  class: "p-field"
}
const _hoisted_66 = { for: "tax_3" }
const _hoisted_67 = { class: "p-col" }
const _hoisted_68 = { class: "p-field" }
const _hoisted_69 = {
  key: 0,
  class: "p-error"
}
const _hoisted_70 = { class: "p-field" }
const _hoisted_71 = {
  key: 0,
  class: "p-error"
}
const _hoisted_72 = { class: "p-field" }
const _hoisted_73 = {
  key: 0,
  class: "p-error"
}
const _hoisted_74 = { class: "confirmation-content" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-exclamation-triangle p-mr-3",
  style: {"font-size":"2rem"}
}, null, -1))
const _hoisted_76 = /*#__PURE__*/_createTextVNode("Are you sure to delete ")
const _hoisted_77 = /*#__PURE__*/_createTextVNode(" ?")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_Toolbar, null, {
          start: _withCtx(() => [
            _createVNode(_component_Breadcrumb, {
              home: _ctx.home,
              model: _ctx.items,
              class: "p-menuitem-text"
            }, null, 8, ["home", "model"])
          ]),
          end: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_Dropdown, {
                placeholder: "Choose Store",
                modelValue: _ctx.selectedStore,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedStore) = $event)),
                options: _ctx.storeList,
                optionLabel: "name",
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadList(0)))
              }, null, 8, ["modelValue", "options"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_InputText, {
                modelValue: _ctx.keyword,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.keyword) = $event)),
                modelModifiers: { trim: true },
                placeholder: "Product Name, Generic Name, Batch No",
                style: {"width":"20rem"}
              }, null, 8, ["modelValue"]),
              _createVNode(_component_Button, {
                icon: "pi pi-search ",
                class: "p-button-success p-mr-1",
                onClick: _ctx.loadSearchData
              }, null, 8, ["onClick"])
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_DataTable, {
            first: _ctx.goToFirstLink,
            "onUpdate:first": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.goToFirstLink) = $event)),
            firstModifiers: { sync: true },
            value: _ctx.lists,
            dataKey: "id",
            ref: "dt",
            lazy: true,
            paginator: _ctx.checkPagination,
            rows: _ctx.limit,
            totalRecords: _ctx.totalRecords,
            resizableColumns: true,
            columnResizeMode: "expand",
            responsiveLayout: "scroll",
            onPage: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onPage($event))),
            class: "p-datatable-sm p-datatable-striped p-datatable-gridlines"
          }, {
            empty: _withCtx(() => [
              _hoisted_5
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, { header: "Created Date" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_ctx.formatDateTime(slotProps.data.created_at)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Updated Date" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_ctx.formatDateTime(slotProps.data.updated_at)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Product Name" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.product_name), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Generic Name" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.generic), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Barcode" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.barcode), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Pack Size" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.pack_size), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Strip Size" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.strip_size), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Pack" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.pack), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Strip" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.strip), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Unit" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.unit), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Batch No" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.batch_no), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                header: 'Pack Purchase Price (' + _ctx.currency + ')'
              }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.pack_purchase_price), 1)
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_Column, {
                header: 'Strip Purchase Price (' + _ctx.currency + ')'
              }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.strip_purchase_price), 1)
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_Column, {
                header: 'Unit Purchase Price (' + _ctx.currency + ')'
              }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.unit_purchase_price), 1)
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_Column, {
                header: 'Pack Sale Price (' + _ctx.currency + ')'
              }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.pack_sale_price), 1)
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_Column, {
                header: 'Strip Sale Price (' + _ctx.currency + ')'
              }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.strip_sale_price), 1)
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_Column, {
                header: 'Unit Sale Price (' + _ctx.currency + ')'
              }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.unit_sale_price), 1)
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_Column, { header: "Disc %" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.discount_percentage) + " % ", 1)
                ]),
                _: 1
              }),
              (_ctx.taxNames[0].show == 'true')
                ? (_openBlock(), _createBlock(_component_Column, {
                    key: 0,
                    header: _ctx.taxNames[0].taxName + '(%)'
                  }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(slotProps.data.tax_1) + " % ", 1)
                    ]),
                    _: 1
                  }, 8, ["header"]))
                : _createCommentVNode("", true),
              (_ctx.taxNames[1].show == 'true')
                ? (_openBlock(), _createBlock(_component_Column, {
                    key: 1,
                    header: _ctx.taxNames[1].taxName + '(%)'
                  }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(slotProps.data.tax_2) + " % ", 1)
                    ]),
                    _: 1
                  }, 8, ["header"]))
                : _createCommentVNode("", true),
              (_ctx.taxNames[2].show == 'true')
                ? (_openBlock(), _createBlock(_component_Column, {
                    key: 2,
                    header: _ctx.taxNames[2].taxName + '(%)'
                  }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(slotProps.data.tax_3) + " % ", 1)
                    ]),
                    _: 1
                  }, 8, ["header"]))
                : _createCommentVNode("", true),
              _createVNode(_component_Column, { header: "Expiry Date" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_ctx.formatExpiry(slotProps.data.expiry_date)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Min Stock (Pack)" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.min_stock), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Store Location" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.item_location), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                exportable: false,
                header: "Action"
              }, {
                body: _withCtx((slotProps) => [
                  _createVNode(_component_Button, {
                    icon: "pi pi-pencil",
                    label: "Adjust Stock",
                    class: "p-button-rounded p-button-success p-mr-2",
                    onClick: ($event: any) => (_ctx.editIem(slotProps.data))
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_Button, {
                    icon: "pi pi-trash",
                    class: "p-button-rounded p-button-danger",
                    onClick: ($event: any) => (_ctx.confirmChangeStatus(slotProps.data))
                  }, null, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["first", "value", "paginator", "rows", "totalRecords"])
        ])
      ])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.productDialog,
      "onUpdate:visible": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.productDialog) = $event)),
      style: { width: '100vw' },
      maximizable: false,
      position: "top",
      class: "p-fluid p-m-0 p-dialog-maximized"
    }, {
      header: _withCtx(() => [
        _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.dialogTitle), 1)
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          type: "submit",
          label: "Save",
          icon: "pi pi-check",
          class: "p-button-primary",
          onClick: _cache[33] || (_cache[33] = _withModifiers(($event: any) => (_ctx.saveItem(!_ctx.v$.$invalid)), ["prevent"]))
        })
      ]),
      default: _withCtx(() => [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("label", {
                for: "productName",
                class: _normalizeClass({ 'p-error': _ctx.v$.productName.$invalid && _ctx.submitted })
              }, "Product Name", 2),
              _createVNode(_component_InputText, {
                id: "productName",
                modelValue: _ctx.v$.productName.$model,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.v$.productName.$model) = $event)),
                class: _normalizeClass({ 'p-invalid': _ctx.v$.productName.$invalid && _ctx.submitted }),
                placeholder: "e.g Panadol"
              }, null, 8, ["modelValue", "class"]),
              (
              (_ctx.v$.productName.$invalid && _ctx.submitted) ||
              _ctx.v$.productName.$pending.$response
            )
                ? (_openBlock(), _createElementBlock("small", _hoisted_11, _toDisplayString(_ctx.v$.productName.required.$message.replace("Value", "Product Name")), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("label", {
                for: "generic",
                class: _normalizeClass({ 'p-error': _ctx.v$.generic.$invalid && _ctx.submitted })
              }, "Generic Name", 2),
              _createVNode(_component_InputText, {
                id: "generic",
                modelValue: _ctx.v$.generic.$model,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.v$.generic.$model) = $event)),
                class: _normalizeClass({ 'p-invalid': _ctx.v$.generic.$invalid && _ctx.submitted }),
                placeholder: "e.g Paracetamol"
              }, null, 8, ["modelValue", "class"]),
              (
              (_ctx.v$.generic.$invalid && _ctx.submitted) ||
              _ctx.v$.generic.$pending.$response
            )
                ? (_openBlock(), _createElementBlock("small", _hoisted_13, _toDisplayString(_ctx.v$.generic.required.$message.replace("Value", "Generic Name")), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(_component_InputText, {
                id: "barcode",
                modelValue: _ctx.item.barcode,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.item.barcode) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createVNode(_component_Dropdown, {
                id: "productType",
                modelValue: _ctx.v$.productType.$model,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.v$.productType.$model) = $event)),
                options: _ctx.productType,
                placeholder: "Product Type",
                filter: true,
                optionLabel: "option_name",
                optionValue: "id"
              }, null, 8, ["modelValue", "options"]),
              (
              (_ctx.v$.productType.$invalid && _ctx.submitted) ||
              _ctx.v$.productType.$pending.$response
            )
                ? (_openBlock(), _createElementBlock("small", _hoisted_18, _toDisplayString(_ctx.v$.productType.required.$message.replace("Value", "Product Type")), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createVNode(_component_InputText, {
                id: "Description",
                modelValue: _ctx.item.description,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.item.description) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createVNode(_component_Dropdown, {
                id: "brand",
                modelValue: _ctx.v$.brand.$model,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.v$.brand.$model) = $event)),
                options: _ctx.brand,
                placeholder: "Brand",
                filter: true,
                optionLabel: "option_name",
                optionValue: "id"
              }, null, 8, ["modelValue", "options"]),
              (
              (_ctx.v$.brand.$invalid && _ctx.submitted) || _ctx.v$.brand.$pending.$response
            )
                ? (_openBlock(), _createElementBlock("small", _hoisted_23, _toDisplayString(_ctx.v$.brand.required.$message.replace("Value", "Brand")), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createVNode(_component_Dropdown, {
                id: "brandSector",
                modelValue: _ctx.v$.brandSector.$model,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.v$.brandSector.$model) = $event)),
                options: _ctx.brandSector,
                placeholder: "Brand Sector",
                filter: true,
                optionLabel: "option_name",
                optionValue: "id"
              }, null, 8, ["modelValue", "options"]),
              (
              (_ctx.v$.brandSector.$invalid && _ctx.submitted) ||
              _ctx.v$.brandSector.$pending.$response
            )
                ? (_openBlock(), _createElementBlock("small", _hoisted_27, _toDisplayString(_ctx.v$.brandSector.required.$message.replace("Value", "Brand Sector")), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _createVNode(_component_Dropdown, {
                id: "category",
                modelValue: _ctx.v$.category.$model,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.v$.category.$model) = $event)),
                options: _ctx.category,
                placeholder: "Category",
                filter: true,
                optionLabel: "option_name",
                optionValue: "id"
              }, null, 8, ["modelValue", "options"]),
              (
              (_ctx.v$.category.$invalid && _ctx.submitted) ||
              _ctx.v$.category.$pending.$response
            )
                ? (_openBlock(), _createElementBlock("small", _hoisted_30, _toDisplayString(_ctx.v$.category.required.$message.replace("Value", "Category")), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _createVNode(_component_InputText, {
                id: "sideEffects",
                modelValue: _ctx.item.sideEffects,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.item.sideEffects) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("label", {
                for: "packSize",
                class: _normalizeClass({ 'p-error': _ctx.v$.packSize.$invalid && _ctx.submitted })
              }, "Pack Size", 2),
              _createVNode(_component_InputNumber, {
                id: "packSize",
                modelValue: _ctx.v$.packSize.$model,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.v$.packSize.$model) = $event)),
                useGrouping: false,
                disabled: true,
                class: _normalizeClass({ 'p-invalid': _ctx.v$.packSize.$invalid && _ctx.submitted })
              }, null, 8, ["modelValue", "class"]),
              (
              (_ctx.v$.packSize.$invalid && _ctx.submitted) ||
              _ctx.v$.packSize.$pending.$response
            )
                ? (_openBlock(), _createElementBlock("small", _hoisted_34, _toDisplayString(_ctx.v$.packSize.required.$message.replace("Value", "Pack Size")), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("label", {
                for: "stripSize",
                class: _normalizeClass({ 'p-error': _ctx.v$.stripSize.$invalid && _ctx.submitted })
              }, "Strip Size", 2),
              _createVNode(_component_InputNumber, {
                id: "stripSize",
                modelValue: _ctx.v$.stripSize.$model,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.v$.stripSize.$model) = $event)),
                disabled: true,
                class: _normalizeClass({ 'p-invalid': _ctx.v$.stripSize.$invalid && _ctx.submitted }),
                useGrouping: false
              }, null, 8, ["modelValue", "class"]),
              (
              (_ctx.v$.stripSize.$invalid && _ctx.submitted) ||
              _ctx.v$.stripSize.$pending.$response
            )
                ? (_openBlock(), _createElementBlock("small", _hoisted_36, _toDisplayString(_ctx.v$.stripSize.required.$message.replace("Value", "Strip Size")), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("label", {
                for: "batchNo",
                class: _normalizeClass({ 'p-error': _ctx.v$.batchNo.$invalid && _ctx.submitted })
              }, "Batch No", 2),
              _createVNode(_component_InputText, {
                id: "batchNo",
                modelValue: _ctx.v$.batchNo.$model,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.v$.batchNo.$model) = $event)),
                class: _normalizeClass({ 'p-invalid': _ctx.v$.batchNo.$invalid && _ctx.submitted })
              }, null, 8, ["modelValue", "class"]),
              (
              (_ctx.v$.batchNo.$invalid && _ctx.submitted) ||
              _ctx.v$.batchNo.$pending.$response
            )
                ? (_openBlock(), _createElementBlock("small", _hoisted_38, _toDisplayString(_ctx.v$.batchNo.required.$message.replace("Value", "Batch No")), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("label", {
                for: "pack",
                class: _normalizeClass({ 'p-error': _ctx.v$.pack.$invalid && _ctx.submitted })
              }, "Pack", 2),
              _createVNode(_component_InputNumber, {
                id: "pack",
                modelValue: _ctx.v$.pack.$model,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.v$.pack.$model) = $event)),
                class: _normalizeClass({ 'p-invalid': _ctx.v$.pack.$invalid && _ctx.submitted }),
                useGrouping: false
              }, null, 8, ["modelValue", "class"]),
              (
              (_ctx.v$.pack.$invalid && _ctx.submitted) ||
              _ctx.v$.pack.$pending.$response
            )
                ? (_openBlock(), _createElementBlock("small", _hoisted_41))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("label", {
                for: "strip",
                class: _normalizeClass({ 'p-error': _ctx.v$.strip.$invalid && _ctx.submitted })
              }, "Strip", 2),
              _createVNode(_component_InputNumber, {
                id: "strip",
                modelValue: _ctx.v$.strip.$model,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.v$.strip.$model) = $event)),
                class: _normalizeClass({ 'p-invalid': _ctx.v$.strip.$invalid && _ctx.submitted }),
                useGrouping: false
              }, null, 8, ["modelValue", "class"]),
              (
              (_ctx.v$.strip.$invalid && _ctx.submitted) ||
              _ctx.v$.strip.$pending.$response
            )
                ? (_openBlock(), _createElementBlock("small", _hoisted_43))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("label", {
                for: "unit",
                class: _normalizeClass({ 'p-error': _ctx.v$.unit.$invalid && _ctx.submitted })
              }, "Unit", 2),
              _createVNode(_component_InputNumber, {
                id: "unit",
                modelValue: _ctx.v$.unit.$model,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.v$.unit.$model) = $event)),
                class: _normalizeClass({ 'p-invalid': _ctx.v$.unit.$invalid && _ctx.submitted }),
                useGrouping: false
              }, null, 8, ["modelValue", "class"]),
              (
              (_ctx.v$.unit.$invalid && _ctx.submitted) ||
              _ctx.v$.unit.$pending.$response
            )
                ? (_openBlock(), _createElementBlock("small", _hoisted_45))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("label", {
                for: "packPurchasePrice",
                class: _normalizeClass({ 'p-error': _ctx.v$.packPurchasePrice.$invalid && _ctx.submitted })
              }, "Pack Purchase Price", 2),
              _createVNode(_component_InputNumber, {
                id: "batchNo",
                modelValue: _ctx.v$.packPurchasePrice.$model,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.v$.packPurchasePrice.$model) = $event)),
                class: _normalizeClass({ 'p-invalid': _ctx.v$.packPurchasePrice.$invalid && _ctx.submitted })
              }, null, 8, ["modelValue", "class"]),
              (
              (_ctx.v$.packPurchasePrice.$invalid && _ctx.submitted) ||
              _ctx.v$.packPurchasePrice.$pending.$response
            )
                ? (_openBlock(), _createElementBlock("small", _hoisted_47))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("label", {
                for: "stripPurchasePrice",
                class: _normalizeClass({ 'p-error': _ctx.v$.stripPurchasePrice.$invalid && _ctx.submitted })
              }, "Strip Purchase Price", 2),
              _createVNode(_component_InputNumber, {
                id: "batchNo",
                modelValue: _ctx.v$.stripPurchasePrice.$model,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.v$.stripPurchasePrice.$model) = $event)),
                class: _normalizeClass({ 'p-invalid': _ctx.v$.stripPurchasePrice.$invalid && _ctx.submitted })
              }, null, 8, ["modelValue", "class"]),
              (
              (_ctx.v$.stripPurchasePrice.$invalid && _ctx.submitted) ||
              _ctx.v$.stripPurchasePrice.$pending.$response
            )
                ? (_openBlock(), _createElementBlock("small", _hoisted_49))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("label", {
                for: "unitPurchasePrice",
                class: _normalizeClass({ 'p-error': _ctx.v$.unitPurchasePrice.$invalid && _ctx.submitted })
              }, "Unit Purchase Price", 2),
              _createVNode(_component_InputNumber, {
                id: "batchNo",
                modelValue: _ctx.v$.unitPurchasePrice.$model,
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.v$.unitPurchasePrice.$model) = $event)),
                class: _normalizeClass({ 'p-invalid': _ctx.v$.unitPurchasePrice.$invalid && _ctx.submitted })
              }, null, 8, ["modelValue", "class"]),
              (
              (_ctx.v$.unitPurchasePrice.$invalid && _ctx.submitted) ||
              _ctx.v$.unitPurchasePrice.$pending.$response
            )
                ? (_openBlock(), _createElementBlock("small", _hoisted_51))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("div", _hoisted_53, [
              _hoisted_54,
              _createVNode(_component_InputNumber, {
                id: "packSalePrice",
                modelValue: _ctx.item.packSalePrice,
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.item.packSalePrice) = $event)),
                value: _ctx.getPackSalePrice()
              }, null, 8, ["modelValue", "value"])
            ]),
            _createElementVNode("div", _hoisted_55, [
              _hoisted_56,
              _createVNode(_component_InputNumber, {
                id: "stripSalePrice",
                modelValue: _ctx.item.stripSalePrice,
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.item.stripSalePrice) = $event)),
                value: _ctx.getStripSalePrice()
              }, null, 8, ["modelValue", "value"])
            ]),
            _createElementVNode("div", _hoisted_57, [
              _hoisted_58,
              _createVNode(_component_InputNumber, {
                id: "unitSalePrice",
                modelValue: _ctx.item.unitSalePrice,
                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.item.unitSalePrice) = $event)),
                value: _ctx.getUnitSalePrice()
              }, null, 8, ["modelValue", "value"])
            ]),
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("label", {
                for: "disc",
                class: _normalizeClass({ 'p-error': _ctx.v$.disc.$invalid && _ctx.submitted })
              }, "Discount %", 2),
              _createVNode(_component_InputNumber, {
                id: "disc",
                modelValue: _ctx.v$.disc.$model,
                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.v$.disc.$model) = $event)),
                class: _normalizeClass({ 'p-invalid': _ctx.v$.disc.$invalid && _ctx.submitted }),
                useGrouping: false
              }, null, 8, ["modelValue", "class"]),
              ((_ctx.v$.disc.$invalid && _ctx.submitted) || _ctx.v$.disc.$pending.$response)
                ? (_openBlock(), _createElementBlock("small", _hoisted_60, _toDisplayString(_ctx.v$.disc.required.$message.replace("Value", "Disc %")), 1))
                : _createCommentVNode("", true)
            ]),
            (_ctx.taxNames[0].show == 'true')
              ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                  _createElementVNode("label", _hoisted_62, _toDisplayString(_ctx.taxNames[0].taxName), 1),
                  _createVNode(_component_InputNumber, {
                    id: "tax_1",
                    modelValue: _ctx.item.tax_1,
                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.item.tax_1) = $event)),
                    useGrouping: false
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.taxNames[1].show == 'true')
              ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                  _createElementVNode("label", _hoisted_64, _toDisplayString(_ctx.taxNames[1].taxName), 1),
                  _createVNode(_component_InputNumber, {
                    id: "tax_2",
                    modelValue: _ctx.item.tax_2,
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.item.tax_2) = $event)),
                    useGrouping: false
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.taxNames[2].show == 'true')
              ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                  _createElementVNode("label", _hoisted_66, _toDisplayString(_ctx.taxNames[2].taxName), 1),
                  _createVNode(_component_InputNumber, {
                    id: "tax_3",
                    modelValue: _ctx.item.tax_3,
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.item.tax_3) = $event)),
                    useGrouping: false
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("label", {
                for: "expiryDate",
                class: _normalizeClass({ 'p-error': _ctx.v$.expiryDate.$invalid && _ctx.submitted })
              }, "Expiry Date", 2),
              _createVNode(_component_Calendar, {
                id: "expiryDate",
                modelValue: _ctx.v$.expiryDate.$model,
                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.v$.expiryDate.$model) = $event)),
                selectionMode: "single",
                dateFormat: "dd-mm-yy",
                class: "p-p-1"
              }, null, 8, ["modelValue"]),
              (
              (_ctx.v$.expiryDate.$invalid && _ctx.submitted) ||
              _ctx.v$.expiryDate.$pending.$response
            )
                ? (_openBlock(), _createElementBlock("small", _hoisted_69, _toDisplayString(_ctx.v$.expiryDate.required.$message.replace("Value", "Expiry Date")), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_70, [
              _createElementVNode("label", {
                for: "minStock",
                class: _normalizeClass({ 'p-error': _ctx.v$.minStock.$invalid && _ctx.submitted })
              }, "Minimum Stock Requirement", 2),
              _createVNode(_component_InputText, {
                id: "minStock",
                modelValue: _ctx.v$.minStock.$model,
                "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.v$.minStock.$model) = $event)),
                class: _normalizeClass({ 'p-invalid': _ctx.v$.minStock.$invalid && _ctx.submitted })
              }, null, 8, ["modelValue", "class"]),
              (
              (_ctx.v$.minStock.$invalid && _ctx.submitted) ||
              _ctx.v$.minStock.$pending.$response
            )
                ? (_openBlock(), _createElementBlock("small", _hoisted_71, _toDisplayString(_ctx.v$.minStock.required.$message.replace("Value", "Minimum Stock Requirement")), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_72, [
              _createElementVNode("label", {
                for: "storeLocation",
                class: _normalizeClass({ 'p-error': _ctx.v$.storeLocation.$invalid && _ctx.submitted })
              }, "Store Location", 2),
              _createVNode(_component_InputText, {
                id: "storeLocation",
                modelValue: _ctx.v$.storeLocation.$model,
                "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.v$.storeLocation.$model) = $event)),
                class: _normalizeClass({ 'p-invalid': _ctx.v$.storeLocation.$invalid && _ctx.submitted })
              }, null, 8, ["modelValue", "class"]),
              (
              (_ctx.v$.storeLocation.$invalid && _ctx.submitted) ||
              _ctx.v$.storeLocation.$pending.$response
            )
                ? (_openBlock(), _createElementBlock("small", _hoisted_73, _toDisplayString(_ctx.v$.storeLocation.required.$message.replace(
                "Value",
                "Store Location"
              )), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.statusDialog,
      "onUpdate:visible": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.statusDialog) = $event)),
      style: { width: '450px' },
      header: "Confirm"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "No",
          icon: "pi pi-times",
          class: "p-button-success",
          onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.statusDialog = false))
        }),
        _createVNode(_component_Button, {
          label: "Yes",
          icon: "pi pi-check",
          class: "p-button-danger",
          onClick: _ctx.changeStockStatus
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_74, [
          _hoisted_75,
          _createElementVNode("span", null, [
            _hoisted_76,
            _createElementVNode("b", null, _toDisplayString(_ctx.state.productName), 1),
            _hoisted_77
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}